import { useAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { omniAtom } from "src/utils/atoms";

const imagineShelvesSettingsDataAtom = omniAtom({
  key: "modals/imagineShelvesSettings",
  value: null as null | { categoryId: number; storeIds: number[]; started: boolean },
});

export const useModalImagineShelvesSettings = () => {
  const { openModal } = useModals();

  const [imagineShelvesSettingsData, setImagineShelvesSettingsData] = useAtom(
    imagineShelvesSettingsDataAtom,
  );

  const openModalImagineShelvesSettings = (data: { categoryId: number; storeIds: number[] }) => {
    setImagineShelvesSettingsData({ ...data, started: false });
    openModal("ModalImagineShelvesSettings");
  };

  const setImagineShelvesStarted = async () => {
    if (imagineShelvesSettingsData) {
      setImagineShelvesSettingsData({
        ...imagineShelvesSettingsData,
        started: true,
      });
    }
  };

  return {
    openModalImagineShelvesSettings,
    setImagineShelvesStarted,
    imagineShelvesSettingsData,
    setImagineShelvesSettingsData,
  };
};
